import OutletDefaultType from "../types/OutletDefaultType";

export const getOutletMaintenanceFields = (
  isLoading,
  outletState = OutletDefaultType,
  setOutletState
) => {
  return [
    {
      type: "name",
      name: "outlet_desc",
      placeholder: "Outlet Name",
      label: "Outlet Name",
      autofocus: true,
      required: true,
      disabled: isLoading,
      value: outletState.outlet_desc,
      setValue: (e) => {
        const value = e.target.value;
        setOutletState({ ...outletState, outlet_desc: value });
      },
    },
    {
      type: "textarea",
      name: "outlet_address",
      placeholder: "Address",
      label: "Address",
      autofocus: false,
      required: true,
      disabled: isLoading,
      value: "outletState.outlet_address",
      setValue: (e) => {
        const value = e.target.value;
        setOutletState({ ...outletState, outlet_address: value });
      },
    },
    {
      type: "phone",
      name: "outlet_contact",
      placeholder: "123456789",
      label: "Mobile number",
      autofocus: false,
      required: true,
      disabled: isLoading,
      value: outletState.outlet_contact,
      setValue: (e) => {
        const value = e.target.value;
        setOutletState({ ...outletState, outlet_contact: value });
      },
    },
  ];
};
